import React from 'react';

const DEFAULT_COLOR = '#3B82F6';

const normalizeHex = (value) => {
  const hex = String(value || '').trim();
  return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(hex) ? hex : DEFAULT_COLOR;
};

const hexToRgba = (hex, alpha) => {
  const value = normalizeHex(hex).replace('#', '');
  const expanded = value.length === 3
    ? value.split('').map((char) => char + char).join('')
    : value;
  const int = parseInt(expanded, 16);
  const r = (int >> 16) & 255;
  const g = (int >> 8) & 255;
  const b = int & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export default function CourseNameBadge({
  courseName,
  courseCode = '',
  courseColor,
  className = '',
  compact = false,
  title,
}) {
  const label = courseName || 'Course';
  const color = normalizeHex(courseColor);

  return (
    <span
      className={`d-inline-flex align-items-center gap-2 ${className}`.trim()}
      title={title || label}
      style={{
        maxWidth: '100%',
        padding: compact ? '0.18rem 0.45rem' : '0.28rem 0.6rem',
        borderRadius: 999,
        border: `1px solid ${hexToRgba(color, 0.28)}`,
        background: hexToRgba(color, 0.12),
        color: '#0f172a',
        lineHeight: 1.1,
      }}
    >
      <span
        style={{
          width: compact ? 8 : 10,
          height: compact ? 8 : 10,
          borderRadius: '50%',
          background: color,
          flexShrink: 0,
        }}
      />
      <span className="text-truncate" style={{ minWidth: 0, maxWidth: '100%', fontWeight: 600 }}>
        {label}
      </span>
      {courseCode ? (
        <span className="text-muted small" style={{ flexShrink: 0 }}>
          {courseCode}
        </span>
      ) : null}
    </span>
  );
}
